import * as React from 'react';

const termsSections: { heading: string; body: string[] }[] = [
  {
    heading: 'General information only',
    body: [
      'This site is published by Tour de Cure to explain the NextOnVera initiative to donors, supporters, clinicians and the community. Nothing on it is medical advice, and nothing on it should be used to make decisions about diagnosis or treatment. If you or someone you care for has a cancer diagnosis, please talk to your treating team.'
    ]
  },
  {
    heading: 'Research programs, not products',
    body: [
      'NextOnVera and Grace AI are research programs under validation. They are not included in the Australian Register of Therapeutic Goods and are not available for clinical or patient use. Cancer Navigator is in development. Descriptions on this site explain what these programs are designed to do; they are not claims that they do it.'
    ]
  },
  {
    heading: 'Statistics',
    body: [
      'Figures about brain cancer on this site are drawn from the sources cited beside them and are updated when those sources change.'
    ]
  },
  {
    heading: 'Donations',
    body: [
      'Donations are made to Tour de Cure, which issues receipts and directs funds through its research committee. Donors may express a preference for the Brain Cancer Fund; Tour de Cure retains discretion over how charitable funds are applied, as the law requires.'
    ]
  },
  {
    heading: 'Copyright',
    body: [
      'Content on this site is owned by Tour de Cure unless stated otherwise. You may share it for non-commercial purposes with attribution.'
    ]
  },
  {
    heading: 'Contact',
    body: ['info@nextonvera.com']
  }
];

export function TermsOfUseMedicalInfoPage() {
  React.useEffect(() => {
    const previous = document.title;
    document.title = 'Terms of Use and Medical Information | NextOnVera';
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <article className="px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
      <div className="mx-auto w-full max-w-3xl">
        <p className="text-primary mb-3 text-xs font-medium tracking-[0.2em] uppercase">Legal</p>
        <h1 className="font-display text-foreground text-4xl font-semibold tracking-tight sm:text-5xl">
          Terms of Use and Medical Information
        </h1>
        <p className="text-muted-foreground mt-5 text-base leading-relaxed sm:text-lg">
          The terms that apply to this website and the limits of the medical information on it.
        </p>
        <div className="mt-10 space-y-8">
          {termsSections.map((section) => (
            <section key={section.heading}>
              <h2 className="font-display text-foreground text-xl font-semibold tracking-tight">
                {section.heading}
              </h2>
              <div className="mt-3 space-y-3">
                {section.body.map((paragraph) => (
                  <p
                    key={paragraph}
                    className="text-muted-foreground text-base leading-relaxed"
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </article>
  );
}
